import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';
import { snackBarData } from '../model/snack-bar.model';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  private currentSnackBarRef: any;

  constructor(public snackBar: MatSnackBar) {}

  open(data: snackBarData, style?: { horizontalPosition?: MatSnackBarHorizontalPosition, verticalPosition?: MatSnackBarVerticalPosition }) {
    if (!this.currentSnackBarRef) {
      this.currentSnackBarRef = this.snackBar.openFromComponent(SnackBarComponent, {
        data: [data],
        horizontalPosition: style?.horizontalPosition || 'right',
        verticalPosition: style?.verticalPosition || 'bottom',
      });
    } else {
      this.currentSnackBarRef.instance.addFile(data);
    }
    return this.currentSnackBarRef;
  }

  close() {
    this.currentSnackBarRef = null;
  }
}
